import OperationIcon from '@assets/images/icons/operation.svg';
import SatelliteIcon from '@assets/images/icons/satellite.svg';
import StatusIcon from '@assets/images/icons/status.svg';
import { SquaredBadge } from '@features/ui-atoms/components/SquaredBadge';
import { styled } from '@mui/joy';
import { OperationType } from '@root/src/entities/Sst/operationType/enum';
import { SST_TYPES, SstType } from '@root/src/entities/Sst/sstType/enum';
import { useTranslation } from 'next-i18next';

const SstEventBadge = ({ sstType, operationTypes }: { sstType: SstType; operationTypes: OperationType[] }) => {
  const { t } = useTranslation();
  return (
    <SquaredBadge>
      <BadgeIcon>
        {sstType === SST_TYPES.TRAJECTORY && <SatelliteIcon />}
        {sstType === SST_TYPES.STATUS && <StatusIcon />}
        {sstType === SST_TYPES.OPERATION && <OperationIcon />}
      </BadgeIcon>
      <span>{t(`sstEvent.sstType.${sstType}`)}</span>
      {sstType === SST_TYPES.OPERATION && operationTypes.length > 0 && (
        <div style={{ display: 'flex', gap: '2px' }}>
          {operationTypes.map(operationType => (
            <TypeBadge key={operationType}>{t(`sstEvent.operationTypes.${operationType}`)}</TypeBadge>
          ))}
        </div>
      )}
    </SquaredBadge>
  );
};

export default SstEventBadge;

const TypeBadge = styled('div')(({ theme: { palette } }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: palette.white,
  color: palette.black,
  fontSize: '10px',
  lineHeight: '10px',
  padding: '2px 4px 2px 4px',
  borderRadius: '3px',
}));

const BadgeIcon = styled('div')(({ theme: { palette } }) => ({
  color: palette.bluePrimary,
  width: '14px',
  height: '14px',
  '& > svg': {
    width: '14px',
    height: '14px',
  },
}));
